export default __webpack_public_path__ + "static/media/items-item-1-effect@3x.0d985073.png";